import type { ComponentProps, FunctionComponent } from 'react';
import { SeoFooterTabs } from '@property.com.au/ui-kit';
import { useSuburbPageQuery } from '../../graphql/useSuburbPageQuery';
import { ResultOf } from 'gql.tada';
import { suburbPageQuery } from '../../graphql/suburbPageQuery';

type ApiFooter = NonNullable<
  NonNullable<ResultOf<typeof suburbPageQuery>['suburbPageBySlug']>['seoFooter']
>;

export const mapApiSuburbSeoFooterToSeoFooter = ({
  footerTabsV2: footerTabs,
}: ApiFooter): ComponentProps<typeof SeoFooterTabs> | null => {
  if (!footerTabs?.tabs || footerTabs.tabs.length === 0) return null;

  return {
    title: footerTabs.title,
    tabs: footerTabs.tabs.map((tab) => ({
      ...tab,
      tabContent: {
        title: tab.tabContent?.title,
        links: tab.tabContent?.links?.map((link) => ({
          ...link,
          clickThroughTracking: {
            pathname: link.tracking?.clickThroughTracking?.pathname,
            page: link.tracking?.clickThroughTracking?.page,
            element: link.tracking?.clickThroughTracking?.element,
            sourceType: link.tracking?.clickThroughTracking?.sourceType,
          },
        })),
      },
    })),
  };
};

export const SuburbPageSeoFooterWithData: FunctionComponent = () => {
  const seoFooter = useSuburbPageQuery().data?.suburbPageBySlug?.seoFooter;
  if (!seoFooter) return null;

  const mappedSeoFooter = mapApiSuburbSeoFooterToSeoFooter(seoFooter);
  if (!mappedSeoFooter) return null;

  return (
    <SeoFooterTabs
      title={mappedSeoFooter.title}
      tabs={mappedSeoFooter.tabs}
      hasBackgroundColor={false}
      hasBorderTop
    />
  );
};
